import * as client_hooks from '../../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18')
];

export const server_loads = [];

export const dictionary = {
		"/": [7],
		"/ai": [16],
		"/gis-services": [17,[6]],
		"/gis-services/layer/[id]": [18,[6]],
		"/(product)/safecurves/programs": [9,[2,4,5]],
		"/(product)/safecurves/programs/settings": [15,[2,4,5]],
		"/(product)/safecurves/programs/[programId]": [10,[2,4,5]],
		"/(product)/safecurves/programs/[programId]/new": [14,[2,4,5]],
		"/(product)/safecurves/programs/[programId]/[projectId]": [11,[2,4,5]],
		"/(product)/safecurves/programs/[programId]/[projectId]/add": [13,[2,4,5]],
		"/(product)/safecurves/programs/[programId]/[projectId]/[segmentId]": [12,[2,4,5]],
		"/(product)/[app]/[[view=view]]": [8,[2,3]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ kind, error }) => { if (kind === 'unknown') { console.error(error); } }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);